import React from "react";

export default function BrandOverview({ brand }) {

    const stats = [

        {
            title: "Revenue",
            value: "₹0",
            color: "#10b981"
        },

        {
            title: "Orders",
            value: "0",
            color: "#2563eb"
        },

        {
            title: "Products",
            value: "0",
            color: "#f59e0b"
        },

        {
            title: "Customers",
            value: "0",
            color: "#8b5cf6"
        }

    ];

    return (

        <div>

            {/* Header */}

            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: 30
                }}
            >

                <div>

                    <h1
                        style={{
                            margin: 0,
                            fontSize: 34
                        }}
                    >
                        Welcome back 👋
                    </h1>

                    <div
                        style={{
                            marginTop: 8,
                            color: "#6b7280",
                            fontSize: 16
                        }}
                    >
                        {brand?.brandName}
                    </div>

                </div>

                <button
                    style={{
                        padding: "12px 24px",
                        border: "none",
                        borderRadius: 10,
                        background: "#2563eb",
                        color: "#fff",
                        cursor: "pointer",
                        fontWeight: 600
                    }}
                >
                    + Add Product
                </button>

            </div>

            {/* Stats */}

            <div
                style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fit,minmax(220px,1fr))",
                    gap: 20
                }}
            >

                {

                    stats.map(stat => (

                        <div

                            key={stat.title}

                            style={{

                                background: "#fff",

                                borderRadius: 16,

                                padding: 24,

                                boxShadow: "0 10px 30px rgba(0,0,0,.05)"

                            }}

                        >

                            <div
                                style={{
                                    color: "#888",
                                    marginBottom: 10
                                }}
                            >
                                {stat.title}
                            </div>

                            <div
                                style={{
                                    fontSize: 32,
                                    fontWeight: 700,
                                    color: stat.color
                                }}
                            >
                                {stat.value}
                            </div>

                        </div>

                    ))

                }

            </div>

            {/* Second Row */}

            <div
                style={{
                    display: "grid",
                    gridTemplateColumns: "2fr 1fr",
                    gap: 20,
                    marginTop: 30
                }}
            >

                {/* Activity */}

                <div
                    style={{
                        background: "#fff",
                        borderRadius: 16,
                        padding: 24,
                        boxShadow: "0 10px 30px rgba(0,0,0,.05)"
                    }}
                >

                    <h2
                        style={{
                            marginTop: 0
                        }}
                    >
                        Recent Activity
                    </h2>

                    <div
                        style={{
                            color: "#777",
                            marginTop: 20
                        }}
                    >
                        No recent activity yet.
                    </div>

                </div>

                {/* Quick Actions */}

                <div
                    style={{
                        background: "#fff",
                        borderRadius: 16,
                        padding: 24,
                        boxShadow: "0 10px 30px rgba(0,0,0,.05)"
                    }}
                >

                    <h2
                        style={{
                            marginTop: 0
                        }}
                    >
                        Quick Actions
                    </h2>

                    <button
                        style={{
                            width: "100%",
                            padding: 14,
                            marginTop: 15,
                            borderRadius: 10,
                            border: "none",
                            cursor: "pointer"
                        }}
                    >
                        Add Product
                    </button>

                    <button
                        style={{
                            width: "100%",
                            padding: 14,
                            marginTop: 12,
                            borderRadius: 10,
                            border: "none",
                            cursor: "pointer"
                        }}
                    >
                        Add Service
                    </button>

                    <button
                        style={{
                            width: "100%",
                            padding: 14,
                            marginTop: 12,
                            borderRadius: 10,
                            border: "none",
                            cursor: "pointer"
                        }}
                    >
                        Create Offer
                    </button>

                    <button
                        style={{
                            width: "100%",
                            padding: 14,
                            marginTop: 12,
                            borderRadius: 10,
                            border: "none",
                            cursor: "pointer"
                        }}
                    >
                        View Marketplace
                    </button>

                </div>

            </div>

            {/* Third Row */}

            <div
                style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                    gap: 20,
                    marginTop: 30
                }}
            >

                {/* Sales */}

                <div
                    style={{
                        background: "#fff",
                        borderRadius: 16,
                        padding: 24,
                        minHeight: 300,
                        boxShadow: "0 10px 30px rgba(0,0,0,.05)"
                    }}
                >

                    <h2
                        style={{
                            marginTop: 0
                        }}
                    >
                        Sales Overview
                    </h2>

                    <div
                        style={{
                            marginTop: 80,
                            textAlign: "center",
                            color: "#999"
                        }}
                    >
                        Sales chart will appear here.
                    </div>

                </div>

                {/* Inventory */}

                <div
                    style={{
                        background: "#fff",
                        borderRadius: 16,
                        padding: 24,
                        minHeight: 300,
                        boxShadow: "0 10px 30px rgba(0,0,0,.05)"
                    }}
                >

                    <h2
                        style={{
                            marginTop: 0
                        }}
                    >
                        Inventory Alerts
                    </h2>

                    <div
                        style={{
                            marginTop: 20,
                            color: "#777"
                        }}
                    >
                        Everything looks good.
                    </div>

                </div>

            </div>

        </div>

    );

}